import React from 'react'
import { Block } from '../../Globals'
import { Column, Row, Container } from '@components/Common'
import sideBgImage from '@assets/images/Right_Faded_BW.jpg'
import Table from '../../Table'
import { useMediaQuery } from '@hooks'
import { sizes } from '@theme'
import { CardRow } from '../../Row'

const Professional = ({ tabContent }) => {
  const pros = tabContent
  pros.sort((a, b) => {
    const titleRankA = a?.relatedTitle?.titleGroup?.sortOrder || Infinity
    const titleRankB = b?.relatedTitle?.titleGroup?.sortOrder || Infinity
    const titleRankDiff = titleRankA - titleRankB

    const lastNameDiff = a?.lastName?.localeCompare(b?.lastName)
    const nameDiff = a?.name?.localeCompare(b?.name)

    return titleRankDiff || lastNameDiff || nameDiff
  })

  const columns = [
    { id: 'name', val: 'Name', sort: 'lastName', width: 4.75 },
    { id: 'office', val: 'Office', width: 2.5 },
    { id: 'contact', val: 'Contact', width: 4.75 },
  ]

  const xs = useMediaQuery(`(max-width: ${sizes.xsmall.max})`)
  const sm = useMediaQuery(`(max-width: ${sizes.small.max})`)
  const tablePadding = xs || sm ? 'my-0' : 'md:my-[35px]'

  const rowHeights = {
    xs: 230,
    sm: 230,
    md: 160,
    lg: 120,
    xl: 120,
  }

  return (
    <Block imgUrl={sideBgImage}>
      <Container className="px-[15px] lg:px-0">
        <Row className={`${tablePadding}`}>
          <Column
            className="lg:w-11/12 xl:w-5/6"
            xs={12}
            sm={12}
            md={12}
            lg={11}
            xl={10}
          >
            <Table
              rows={pros}
              columns={columns}
              rowHeights={rowHeights}
              RowComponent={CardRow}
              // enableSorting
              noDataMessage="No professional could be found in this Practice Area"
            />
          </Column>
        </Row>
      </Container>
    </Block>
  )
}

export default Professional
